@if (coordinates$ | async; as coordinates) {
  <div class="mouse-coordinates"
    (pointerenter)="isOverCoordinates(true)"
    (pointerout)="isOverCoordinates(false)"
    (mouseenter)="isOverCoordinates(true)"
    (mouseout)="isOverCoordinates(false)"
    >
    @if (coordinates[0]) {
      <span class="mouse-coordinates__coordinate"
      >{{coordinates[0]}}</span>
    }
    @if (coordinates[0] && coordinates[1]) {
      <span>|</span>
    }
    @if (coordinates[1]) {
      <span class="mouse-coordinates__coordinate"
      >{{coordinates[1]}}</span>
    }
  </div>
}
